module.exports = __webpack_public_path__ + "static/media/23.b14ed7cf.wav";